import React from 'react'
import PropTypes from 'prop-types'

class ServantsList extends React.Component {

  getAvatar = (key) => {
    const { servants, avatars } = this.props

    if (servants && servants[key].avatar) {
      if (avatars && avatars[key]) {
        return avatars[key]
      }
    }
    return ''
  }

  getColor = (rankKey) => {
    if (this.props.ranks) {
      const rankColor = this.props.ranks[rankKey].color
      return rankColor && {color: rankColor}
    }
  }

  getStatus = (status) => {
    if (status) {
      return <img
        src="http://diablo.azmklan.org/grafika/aktywny.png"
        alt="active" title="Aktywny Klanowicz" height="15" width="15"/>
    }
    return <img
      src="http://diablo.azmklan.org/grafika/nieaktywny.png"
      alt="not-active" title="Nieaktywny Klanowicz" height="15" width="15"/>
  }
  render () {
    const { servants, ranks, servantRanks, paragons } = this.props
    return (
      <div>
        { ranks && Object.keys(ranks).map(rankKey => (
          servantRanks && servantRanks[rankKey] &&
          <div key={rankKey}>
            <div className="d2">&nbsp;</div>
            <div className="dark-decor" style={this.getColor(rankKey)}>{ ranks[rankKey].name }</div>
            <div className="d1">&nbsp;</div>
            <div>
              { servantRanks && Object.keys(servantRanks[rankKey]).map(key => (
                <div key={key}
                  style={{
                    backgroundImage: `url(${this.getAvatar(key)})`,
                    width: 400,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '22px 50%',
                    backgroundSize: '60px 60px',
                  }}>
                  <div
                    className="servant--wrapper"
                    style={{
                      backgroundImage: 'url(http://diablo.azmklan.org/grafika/sludzy.png)',
                      width: 399,
                      height: 110,
                      margin: 'auto',
                      textAlign: 'left',
                      display: 'flex',
                      flexDirection: 'row',
                    }}>
                    <div style={{width: 65, marginLeft: 100, marginTop: 20}}>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Nick:</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Paragon:</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Ranga:</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>W AZM od:</p>
                    </div>
                    <div style={{width: '100', marginTop: 20, marginRight: 10}}>
                        <p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].nick}
                          <a href={`http://eu.battle.net/d3/pl/profile/${servants[key].battleTag}/`}
                             target="_blank" rel="noopener noreferrer" title={servants[key].battleTag}>
                            <img src="http://diablo.azmklan.org//grafika/favicon.ico" height="13" alt="Profil"/>
                          </a>
                        </p>
                        <p className="paragon">
                           { paragons && servants[key] && paragons[servants[key].battleTag] ?
                            <span>
                              <span style={{'color':'green', 'fontSize':11}} className="no-paragon">{paragons[servants[key].battleTag].paragonLevel || 0}sc</span>
                              <span style={{'color':'red', 'fontSize':11}} className="hc-paragon">{paragons[servants[key].battleTag].paragonLevelHardcore || 0}hc</span>
                            </span> :
                             <span>{ servants[key].battleTag ? 'Loading' : 'Sekcja Diablo 2' }</span>
                          }
                        </p>
                        <p className="glowing-text" style={this.getColor(rankKey)}>{ranks[rankKey].single}</p>
                        <p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].since}</p>
                    </div>
                    <div style={{width: 55, marginTop: 20}}>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Imię:</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Rocznik:</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Miasto:</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>Status:</p>
                    </div>
                    <div style={{width: 80, marginTop: 20}}>
                      <p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].name}</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].year}</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>{servants[key].city}</p>
                      <p className="glowing-text" style={this.getColor(rankKey)}>{this.getStatus(servants[key].status)}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }
}

ServantsList.propTypes = {
  servants: PropTypes.object,
  avatars: PropTypes.object,
  ranks: PropTypes.object,
  servantRanks: PropTypes.object,
  paragons: PropTypes.object,
}

export default ServantsList



// WEBPACK FOOTER //
// ./src/components/ServantsList.js